'use client';
import { IconFile } from '@tabler/icons-react';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { Cicon } from '@/components/ui/Cicon';
import { Ctext } from '@/components/ui/Ctext';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { getRadiusCssValue } from '@/theme/radius';
import { pxToRem } from '@/theme/spacing';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import type { ReactElement } from 'react';
import { getFakeCommentDisplayFileName, getFakeCommentFileVersionLabel, } from './cfakecommentFileHelpers';
import { FAKE_COMMENT_AUTO_MARGIN } from './cfakecommentConstants';
import type { FakeCommentFileAttachment } from './cfakecommentTypes';
interface FakeCommentFileItemProps {
    dataElScope: DataElScope;
    message: FakeCommentFileAttachment;
    isMobile: boolean;
}
export function FakeCommentFileItem({ dataElScope, message, isMobile, }: FakeCommentFileItemProps): ReactElement {
    const fileVersionLabel = getFakeCommentFileVersionLabel(message);
    const displayFileName = getFakeCommentDisplayFileName(message.fileName);
    const fileDebugIdentity = `${displayFileName}-${fileVersionLabel}`;
    return <Ccontainer rootAttributes={{ 'data-el': dataEl(dataElScope, 'FileItem/Root') }} backgroundColor={ColorType.Black} backgroundOpacity={0.33} borderColor={ColorType.White} borderOpacity={0.06} radius={13} padding="10px 12px" display="flex" alignItems="center" gap={isMobile ? 10 : 12} style={{
            width: 'fit-content',
            maxWidth: '100%',
            backgroundImage: 'linear-gradient(135deg, rgba(255, 255, 255, 0.14) 0%, rgba(102, 254, 193, 0.16) 100%)',
            boxShadow: '#ffffffe8 0px 3px 4px -4px inset, #ffffff75 0px -1px 4px -3px inset, rgba(0, 0, 0, 0.28) 0px 12px 30px -18px',
        }}>
            <div style={{
            width: isMobile ? pxToRem(34) : pxToRem(40),
            height: isMobile ? pxToRem(34) : pxToRem(40),
            borderRadius: getRadiusCssValue(12),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            backgroundImage: 'linear-gradient(180deg, rgba(102, 254, 193, 0.38) 0%, rgba(102, 254, 193, 0.12) 100%)',
            boxShadow: 'rgba(255, 255, 255, 0.18) 0px 1px 0px inset, rgba(0, 0, 0, 0.3) 0px 10px 18px -12px',
        }}>
                <Cicon icon={IconFile} size={isMobile ? 16 : 18} color={ColorType.White} style={{ filter: 'drop-shadow(0 2px 6px rgba(0, 0, 0, 0.18))' }}/>
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: pxToRem(2),
            minWidth: 0,
            flex: 1,
        }}>
                <Ctext size={15} weight={FontWeight.Medium} color={ColorType.White} opacity={0.95} style={{
            lineHeight: 1.35,
            wordBreak: 'break-word',
        }}>
                    {displayFileName}
                </Ctext>
                <Ctext size={12} weight={FontWeight.Medium} color={ColorType.White} opacity={0.55} style={{
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
        }}>
                    Workspace File
                </Ctext>
            </div>
            <Ctext size={11} weight={FontWeight.SemiBold} color={ColorType.White} opacity={0.8} style={{
            marginLeft: FAKE_COMMENT_AUTO_MARGIN,
            padding: `${pxToRem(5)} ${pxToRem(8)}`,
            borderRadius: getRadiusCssValue(999),
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            flexShrink: 0,
        }}>
                {fileVersionLabel}
            </Ctext>
        </Ccontainer>
        ;
}
